export default __webpack_public_path__ + "static/media/building_icon.a47cb66e.png";